import { render } from "./ManageTagPermission.vue?vue&type=template&id=13c9b211"
import script from "./ManageTagPermission.vue?vue&type=script&lang=js"
export * from "./ManageTagPermission.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__